/** CPF com dígitos verificadores (módulo 11). Aceita com ou sem pontuação. */
export function isValidCpf(raw) {
    const d = raw.replace(/\D/g, '');
    if (d.length !== 11 || /^(\d)\1{10}$/.test(d))
        return false;
    const dv = (len) => {
        const sum = Array.from({ length: len }, (_, i) => Number(d[i]) * (len + 1 - i)).reduce((a, b) => a + b, 0);
        const r = (sum * 10) % 11;
        return r === 10 ? 0 : r;
    };
    return dv(9) === Number(d[9]) && dv(10) === Number(d[10]);
}
export function formatCpf(raw) {
    const d = raw.replace(/\D/g, '').slice(0, 11);
    return d.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1-$2');
}
/** Completa os 2 dígitos verificadores de uma base de 9 dígitos (útil em testes e seeds). */
export function withCpfCheckDigits(base9) {
    let d = base9.replace(/\D/g, '').padStart(9, '0').slice(0, 9);
    for (const len of [9, 10]) {
        const sum = Array.from({ length: len }, (_, i) => Number(d[i]) * (len + 1 - i)).reduce((a, b) => a + b, 0);
        const r = (sum * 10) % 11;
        d += String(r === 10 ? 0 : r);
    }
    return d;
}
//# sourceMappingURL=cpf.js.map